
      import CopySimple from './copy-simple.vue'
      import type { App, Plugin } from 'vue'

      export const CopySimplePlugin: Plugin = {
        install(app: App) {
          app.component('CopySimple', CopySimple)
        },
      }
      export { CopySimple }
      